export const sortInitPreviews = (
  fieldsSort: string,
  typeSort: string,
  typeFields: string,
  items: any[]
) => {
  if (!Array.isArray(items)) {
    return [];
  }
  const response = [...items];

  const compareLogic = (a: any, b: any) => {
    let valA = a?.[fieldsSort];
    let valB = b?.[fieldsSort];

    const isAInvalid = valA === null || valA === undefined;
    const isBInvalid = valB === null || valB === undefined;

    if (isAInvalid && isBInvalid) return 0;
    if (isAInvalid) return 1;
    if (isBInvalid) return -1;

    switch (typeFields) {
      case 'string': {
        const strA = String(valA);
        const strB = String(valB);
        const numA = Number(strA);
        const numB = Number(strB);
        const bothNumeric = strA.trim() !== '' && strB.trim() !== '' && !isNaN(numA) && !isNaN(numB);
        if (bothNumeric) {
          return numA - numB;
        }
        return strA.localeCompare(strB);
      }

      case 'date':
        valA = new Date(valA);
        valB = new Date(valB);
        if (isNaN(valA.getTime())) return 1;
        if (isNaN(valB.getTime())) return -1;
        return valA.getTime() - valB.getTime();

      case 'number':
        const numA = Number(valA);
        const numB = Number(valB);
        if (isNaN(numA)) return 1;
        if (isNaN(numB)) return -1;

        if (numA > numB) return 1;
        if (numB > numA) return -1;
        return 0;

      default:
        return 0;
    }
  };

  response.sort((a, b) => {
    const order = compareLogic(a, b);
    return typeSort === 'desc' ? -order : order;
  });

  return response;
};
